import './index.scss';
import React, { useState } from 'react';
import AddServiceCallContent from '../../pages/service-call/AddServiceCallContent';
import SupportSuccessMessage from '../../pages/service-call/SupportSuccessMessage';

const AddServiceCallModal = () => {
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [serviceCallId, setServiceCallId] = useState<number>();

  return (
    <div className="add-service-call-modal">
      <div className="form-modal">
        {!showSuccessPage && (
          <AddServiceCallContent
            setShowSuccessPage={setShowSuccessPage}
            setServiceCallId={setServiceCallId}
          />
        )}
        {showSuccessPage && (
          <SupportSuccessMessage serviceCallId={serviceCallId || 0} />
        )}
      </div>
    </div>
  );
};

export default AddServiceCallModal;
